import { render, staticRenderFns } from "./DoctorsShowAllLink.vue?vue&type=template&id=568aadfd&scoped=true&"
import script from "./DoctorsShowAllLink.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorsShowAllLink.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./DoctorsShowAllLink.vue?vue&type=style&index=0&id=568aadfd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568aadfd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('568aadfd')) {
      api.createRecord('568aadfd', component.options)
    } else {
      api.reload('568aadfd', component.options)
    }
    module.hot.accept("./DoctorsShowAllLink.vue?vue&type=template&id=568aadfd&scoped=true&", function () {
      api.rerender('568aadfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsList/components/DoctorsShowAllLink.vue"
export default component.exports